import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';

import { Page, PageType } from '../../helpers/page';

import { DocsService } from '../../services/docs.service';
import { LoaderService } from '../../services/loader.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
    selector: 'kd-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {

    contentString: string;
    page: Page;
    ready = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private docsService: DocsService,
        private loaderService: LoaderService,
        private navigationService: NavigationService,
    ) { }

    async ngOnInit() {
        this.navigationService.onNavigation().subscribe(() => {
            this.openPage();
        });

        this.docsService.getPageChange().subscribe(() => {
            this.page = this.docsService.getPage();

            if (!this.page) {
                return;
            }

            if (this.isReleaseNotes()) {
                this.contentString = null;
            } else {
                this.initContent();
            }
        });

        this.docsService.getVersionChange().subscribe(() => {
            this.initContent();
        });

        await this.openPage();
        this.ready = true;
    }

    private initContent(): void {
        this.contentString = this.docsService.getContentString();
        this.docsService.emitContentChange();
    }

    isReleaseNotes(): boolean {
        return this.page.page_type === PageType.ReleaseNotes;
    }

    private async openPage(): Promise<void> {
        const params: ParamMap = this.activatedRoute.snapshot.paramMap;

        const appSlug: string = params.get('app');
        const categorySlug: string = params.get('category');
        const pageSlug: string = params.get('page');

        this.loaderService.start();
        await this.docsService.openPage(appSlug, categorySlug, pageSlug).catch(() => {});
        this.loaderService.stop();
    }
}
